import { Paper, Stack, Switch, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";

import { useThemeMode } from "../theme/theme-mode.context";

interface ThemeModeToggleProps {
  embedded?: boolean;
}

const ThemeModeToggle = ({ embedded = false }: ThemeModeToggleProps) => {
  const { isDarkMode, toggleThemeMode } = useThemeMode();
  const content = (
    <Stack direction="row" spacing={1} alignItems="center">
      <Typography
        variant={embedded ? "body2" : "caption"}
        sx={{
          fontWeight: 700,
          letterSpacing: embedded ? "normal" : "0.12em",
          textTransform: embedded ? "none" : "uppercase",
          color: "text.secondary",
        }}
      >
        {isDarkMode ? "Dark mode" : "Light mode"}
      </Typography>
      <Switch
        checked={isDarkMode}
        size="small"
        inputProps={{ "aria-label": "Toggle color theme" }}
        onChange={() => toggleThemeMode()}
      />
    </Stack>
  );

  if (embedded) {
    return content;
  }

  return (
    <Paper
      variant="outlined"
      sx={(theme) => ({
        px: 1.5,
        py: 0.5,
        borderRadius: 999,
        borderColor: "divider",
        backgroundColor: alpha(
          theme.palette.background.paper,
          theme.palette.mode === "dark" ? 0.88 : 0.94,
        ),
      })}
    >
      {content}
    </Paper>
  );
};

export default ThemeModeToggle;
